class ObligationService {
    constructor(apiConfig, http) {
        const { siteInfo } = apiConfig;
        const { storeId } = siteInfo;
        this.siteInfo = siteInfo;
        this.apiConfig = apiConfig;
        this.http = http;
        this.path = `/wcs/resources/store/${storeId}/HPObligationService`;
    }

    /**
     * Fetch page data
     * @param {string} template - template key of the page
     * @param {string} vanityUrl - the relative path of the page
     * @returns
     */
    get(config = {}) {
        return this.http.get(`${this.path}`, config).then(resp => {
            const { data, status } = resp;
            //attempt to parse response
            if (status === 200 && data && data !== '') {
                return data;
            } else {
                return Promise.reject({});
            }
        });
    }

    /**
     *
     * @param {string} eCarePackSN - the serial number imputed by the customer
     * @param {boolean} isCCFlow - is call center user
     * @param {*} cpOrderItemId - cart item id if of current carepack
     * @returns
     */
    eCarePackSerialNumberValidation(
        eCarePackSN,
        eCarePackCatEntryId,
        isCCFlow,
        cpOrderItemId,
        ObligationServiceEnable = true,
    ) {
        return this.get({
            params: {
                eCarePackSN,
                eCarePackCatEntryId,
                isCCFlow,
                cpOrderItemId,
                ObligationServiceEnable,
            },
        });
    }

    obligationServiceCommand(ecOrderItemId, validSerialNums, eCarePackSN, eCarePackCatEntryId, ccf, config = {}) {
        const data = {
            eCarePackSN,
            ecOrderItemId,
            newQty: 2,
            validSerialNums,
            ObligationServiceEnable: false,
            eCarePackCatEntryId,
            storeId: 10151,
            langId: -1,
            catalogId: 10051,
            ccf,
            cql: 40,
            cal: 12000,
            ...this.siteInfo,
        };

        return this.http.post(`CarePackObligationServiceCmd`, Helpers.parseFormData({ ...data, ...config }));
    }

    obligationServiceCommandUpdate(orderId, orderItemId, quantity, eCarepackSNs, ccf, config) {
        const data = {
            orderId,
            calculationUsage: '-1,-2,-3,-4,-5,-6,-7',
            inventoryValidation: true,
            orderItemId,
            quantity,
            storeId: 10151,
            langId: -1,
            catalogId: 10051,
            ccf,
            cql: 40,
            cal: 12000,
            eCarepackSNs,
            ...this.siteInfo,
        };
        return this.http.post(`CarePackUpdateECPDataExtnCmd`, Helpers.parseFormData({ ...data, ...config }));
    }
}

export default ObligationService;
